import React from 'react'
import Drawer, { DrawerProps } from '@mui/material/Drawer'
import styled from 'styled-components'
import palette from 'core-system/Themes/palette'
import { Close } from 'core-system/Icons/Actions'

const SummaryDrawer = styled(Drawer)<{ width?: string }>`
  overflow: auto;
  height: 100%;
  & .MuiPaper-root {
    width: ${(props) => props.width};
    scrollbar-width: thin;
    scrollbar-color: ${palette.grey.grey200} ${palette.grey.grey100};
  }

  // width 100% on mobile
  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    & .MuiPaper-root {
      width: 100%;
    }
  }
`

const CloseButton = styled.div`
  display: none;
  // only on mobile
  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    position: absolute;
    top: 1rem;
    left: 1rem;
    z-index: 1000;
    display: block;
  }
`

const ChildrenContainer = styled.div`
  margin-bottom: 5rem;
`

interface DrawerPropsContainer extends DrawerProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  anchor?: 'left' | 'right' | 'top' | 'bottom'
  width?: string
}

const DrawerView = ({
  isOpen,
  onClose,
  children,
  anchor = 'right',
  width = '40rem',
  ...props
}: DrawerPropsContainer) => {
  return (
    <SummaryDrawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      width={width}
      {...props}
    >
      <ChildrenContainer>{children}</ChildrenContainer>
      <CloseButton>
        <Close onClick={onClose} />
      </CloseButton>
    </SummaryDrawer>
  )
}

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  DrawerView.displayName = 'DrawerView'
}

export default React.memo(DrawerView)
